/*
 * Concern Orbit detail panel: hovering or focusing a concern shows its blurb and products.
 * The panel also moves through the concerns by itself (every 3.5 s while the section is on screen), so phones,
 * which have no hover, see every concern too. It holds while a finger, the mouse or keyboard focus is in the
 * section, and its height is fixed to the tallest concern so the page never jumps.
 */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STEP = 3500;

  function init(section) {
    const detail = section.querySelector('[data-orbit-detail]');
    if (!detail || section.dataset.ready) return;
    section.dataset.ready = '1';
    const panels = {};
    section.querySelectorAll('template[data-concern-panel]').forEach(t => { panels[t.dataset.concernPanel] = t; });
    const keys = Object.keys(panels);
    let current = null;
    const show = (key, animate) => {
      const t = panels[key];
      if (!t || key === current) return;
      current = key;
      detail.replaceChildren(t.content.cloneNode(true));
      if (animate && !reduce && detail.animate) detail.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'ease-out' });
      section.querySelectorAll('[data-concern]').forEach(el => el.classList.toggle('is-active', el.dataset.concern === key));
    };
    section.addEventListener('pointerover', e => { const c = e.target.closest('.orbit__chip'); if (c) show(c.dataset.concern, true); });
    section.addEventListener('focusin', e => { const c = e.target.closest('[data-concern]'); if (c) show(c.dataset.concern, true); });
    const orbit = section.querySelector('[data-orbit]');
    if (orbit) {
      let release;
      orbit.addEventListener('pointerdown', () => { clearTimeout(release); orbit.classList.add('is-held'); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(t => orbit.addEventListener(t, () => { release = setTimeout(() => orbit.classList.remove('is-held'), 1500); }));
    }
    const first = section.querySelector('template[data-default]');
    if (first) show(first.dataset.concernPanel);

    // Fixed height = the tallest concern, measured once the panel is visible (and again on resize)
    const fitHeight = () => {
      if (!detail.offsetParent) return;
      const keep = current; let tallest = 0;
      detail.style.minHeight = '';
      keys.forEach(k => { detail.replaceChildren(panels[k].content.cloneNode(true)); tallest = Math.max(tallest, detail.offsetHeight); });
      current = null; show(keep);
      detail.style.minHeight = tallest + 'px';
    };

    if (reduce || keys.length < 2 || !('IntersectionObserver' in window)) return;
    let timer = null, onScreen = false;
    const held = new Set();
    const tick = () => { show(keys[(keys.indexOf(current) + 1) % keys.length], true); };
    const sync = () => {
      const go = onScreen && !held.size && !document.hidden;
      if (go && !timer) timer = setInterval(tick, STEP);
      if (!go && timer) { clearInterval(timer); timer = null; }
    };
    const hold = r => { held.add(r); sync(); };
    const free = r => { held.delete(r); sync(); };
    new IntersectionObserver(es => { onScreen = es.some(e => e.isIntersecting); if (onScreen && !detail.style.minHeight) fitHeight(); sync(); }, { threshold: .25 }).observe(section);
    section.addEventListener('mouseenter', () => hold('mouse'));
    section.addEventListener('mouseleave', () => free('mouse'));
    detail.addEventListener('touchstart', () => { hold('touch'); clearTimeout(detail._t); }, { passive: true });
    detail.addEventListener('touchend', () => { detail._t = setTimeout(() => free('touch'), 4000); });
    section.addEventListener('focusin', e => { if (e.target.matches(':focus-visible')) hold('focus'); });
    section.addEventListener('focusout', e => { if (!section.contains(e.relatedTarget)) free('focus'); });
    document.addEventListener('visibilitychange', sync);
    let w = innerWidth;
    addEventListener('resize', () => { if (innerWidth !== w) { w = innerWidth; detail.style.minHeight = ''; fitHeight(); } });
  }
  document.querySelectorAll('[data-orbit-section]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-orbit-section]').forEach(init));
})();
